import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTopProducts, setAnalyticsDateRange } from '../../redux/actions/analyticsAction';
import FYSelector from '../../components/utility/FYSelector';
import Loader from '../../utility/Loader';

const TopProducts = () => {
    const dispatch = useDispatch();
    const { topProducts, loading, startDate, endDate, financialYear } = useSelector(state => state.analytics);

    useEffect(() => {
        dispatch(getTopProducts(startDate, endDate));
    }, [dispatch, financialYear]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleDateChange = (field, value) => {
        const newStart = field === 'start' ? value : startDate;
        const newEnd = field === 'end' ? value : endDate;
        dispatch(setAnalyticsDateRange(newStart, newEnd));
    };

    const handleApply = () => {
        dispatch(getTopProducts(startDate, endDate));
    };


    return (
        <section className="py-5">
            <div className="container">
                <div className="mb-4">
                    <h2 className="text-primary fw-bold mb-1">Top Products</h2>
                    <p className="text-muted mb-0">Ranked by quantity sold · Tax Invoice {financialYear.slice(0,2)}-{financialYear.slice(2)} only</p>
                </div>

                <FYSelector />

                {/* Date Range */}
                <div className="card border-0 shadow-sm mb-4 p-3" style={{ borderRadius: '12px' }}>
                    <div className="row g-3 align-items-end">
                        <div className="col-auto">
                            <label className="form-label small text-muted fw-semibold mb-1">START DATE</label>
                            <input type="date" className="form-control" value={startDate} onChange={e => handleDateChange('start', e.target.value)} />
                        </div>
                        <div className="col-auto">
                            <label className="form-label small text-muted fw-semibold mb-1">END DATE</label>
                            <input type="date" className="form-control" value={endDate} onChange={e => handleDateChange('end', e.target.value)} />
                        </div>
                        <div className="col-auto">
                            <button className="btn btn-primary btn-sm" onClick={handleApply}>
                                Apply
                            </button>
                        </div>
                    </div>
                </div>

                {loading ? <Loader /> : (
                    <div className="card border-0 shadow-sm" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead style={{ background: '#f8f9fa' }}>
                                    <tr>
                                        <th className="px-4 py-3 border-0 text-muted small fw-semibold">#</th>
                                        <th className="px-4 py-3 border-0 text-muted small fw-semibold">PRODUCT NAME</th>
                                        <th className="px-4 py-3 border-0 text-muted small fw-semibold text-center">QTY SOLD</th>
                                        <th className="px-4 py-3 border-0 text-muted small fw-semibold text-end">TOTAL REVENUE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {topProducts && topProducts.length > 0 ? (
                                        topProducts.map((product, index) => (
                                            <tr key={index}>
                                                <td className="px-4 py-3 text-muted">{index + 1}</td>
                                                <td className="px-4 py-3 fw-medium">{product.name || '—'}</td>
                                                <td className="px-4 py-3 text-center">
                                                    <span className="badge bg-primary bg-opacity-70 text-white fw-semibold px-2 py-1">
                                                        {product.totalQuantity}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-3 text-end fw-bold">
                                                    ₹{product.totalRevenue?.toLocaleString('en-IN')}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center py-5 text-muted">
                                                No data found for the selected date range
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default TopProducts;
